<!-- ================= Filters ================= -->
<ion-row class="ion-align-items-center">
  <ion-col size="12" size-md="auto">
    <h6 class="comp-header">Approve Team DWM</h6>
  </ion-col>
  <ion-col size="12" size-md>
    <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
      <button type="button" class="center-content">
        <u class="cp link fs_14ForMobile" (click)="applyDataFilters('', '', false)">Clear Filter</u>
      </button>

      <ng-select  class="w-100 mw-sm-150 mat-height40 mat-input-style" *ngIf="dwmManagerUser" [clearable]="false" placeholder="Select Employee" (change)="applyDataFilters($event, 'selectedEmpId')" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom">
        <ng-option [value]="item.id" *ngFor="let item of dwmManagerUser">{{ item.firstName }} {{ item.lastName }}</ng-option>
      </ng-select>

      <mat-form-field   *ngIf="selectedFilters.selectedDwmType !== 'Annually'"  class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <mat-select placeholder="Select Month" (selectionChange)="applyDataFilters($event.value, 'selectedMonth')" [(ngModel)]="selectedFilters.selectedMonth" dropdownPosition="bottom">
          <mat-option *ngFor="let month of monthsList" [value]="month">{{month}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <mat-select placeholder="Select Year" (selectionChange)="applyDataFilters($event.value, 'selectedYear')" [(ngModel)]="selectedFilters.selectedYear" dropdownPosition="bottom">
          <mat-option *ngFor="let year of listOfYears" [value]="year.key">{{year.value}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ion-col>
</ion-row>



<div class="table-card-box mb-15">
  <div *ngIf="!selectedFilters.selectedEmpId" class="text-center p-20 fs-14">Please select an employee to view DWM records.</div>
  <ng-container *ngIf="selectedFilters.selectedEmpId">
    <ion-row>
      <ion-col size>
        <div class="phi-flex-wrap-center phi-gap-12 mb-5">
          <mat-form-field class="w-100 mw-sm-175 mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" (input)="onSearch($event)" [(ngModel)]="selectedFilters.searchString" [disabled]="!selectedFilters.selectedEmpId" />
          </mat-form-field>
          <ng-select class="w-100 mw-sm-150" [clearable]="false" placeholder="Dwm Type" [(ngModel)]="selectedFilters.selectedDwmType" [items]="getAllDwmTypes" appendTo="body" dropdownPosition="bottom" (change)="applyDataFilters($event, 'selectedDwmType')">
            <ng-option *ngFor="let f of getAllDwmTypes" [value]="f">{{ f }}</ng-option>
          </ng-select>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap-center phi-gap-12">
          <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedTaskList?.length && showCopyButton && !hasNewEntry" (click)="openCopyPreviousMonthPopup()" [disabled]="!selectedFilters.selectedEmpId">Copy DWM</button>
          <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedTaskList?.length && selectedFilters?.isCutoffTaskEditable" (click)="approvalAllDwms()" [disabled]="!selectedFilters.selectedEmpId">Approve DWM</button>
          <button *ngIf="selectedFilters?.isCutoffTaskEditable" type="button" class="dwm_btn fs-14 fs_12ForMobile" (click)="addNewTask(paginatedData)">+ New DWM</button>
          <div class="download-btns phi-flex-wrap-center phi-gap-12">
            <img src="assets/svg/pdf.svg" class="download-img-btn" (click)="downloadReport('pdf')" />
            <img src="assets/svg/excel.svg" class="download-img-btn" (click)="downloadReport('excel')" />
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="table-container">
      <table class="hover">
        <thead>
          <tr>
            <th class="mat-checkbox-style text-center">
              <mat-checkbox value="true" [disabled]="!selectedFilters?.isCutoffTaskEditable" [(ngModel)]="isAllSelected" matTooltip="Select all tasks on this page" (change)="selectALLDwms($event, paginatedData)"></mat-checkbox>
            </th>
            <ng-container *ngFor="let item of teamTableHeaders; let i = index">
              <th class="fs-14 fs_12ForMobile font_bold cl-black sortable" (click)="onSort(item.key)">
                <div class="verticle-center justify-content-space-between icon-style">
                  {{ item.label }}
                  <div class="sort-records-container d-flex flex-column ml-5">
                    <ion-icon name="caret-up-outline" [class.active]="tableState.sortColumn === item.key && tableState.sortDirection === 'asc'"></ion-icon>
                    <ion-icon name="caret-down-outline" [class.active]="tableState.sortColumn === item.key && tableState.sortDirection === 'desc'"></ion-icon>
                  </div>
                </div>
              </th>
            </ng-container>
          </tr>
        </thead>

        <tbody *ngIf="paginatedData?.length">
          <tr *ngFor="let item of paginatedData; let i = index">
            <!-- Check Box -->
            <td class="mat-checkbox-style text-center">
              <mat-checkbox [checked]="item.checkboxCheck" [(ngModel)]="item.checkboxCheck" (change)="selectSingleDwm($event, item, i)" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable"></mat-checkbox>
            </td>

            <!-- Remaining Data -->
            <td>{{ item.dwmType }}</td>
            <td>
              <ng-select class="w-100 mw-sm-175" [clearable]="false" placeholder="Select Category" [(ngModel)]="item.categoryName" bindLabel="categoryName" bindValue="categoryName" appendTo="body" dropdownPosition="top" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredCategory">
                <ng-container *ngFor="let c of dwmCategories">
                  <ng-option *ngIf="c.categoryName !== 'R&D'" [value]="c">{{ c.categoryName }}</ng-option>
                </ng-container>
              </ng-select>
            </td>
            <td>
              <textarea rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.actionable)" class="min-w-sm-150" [class.field-required]="item?.isRequiredActionable" [(ngModel)]="item.actionable" placeholder="Type here.." [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable"></textarea>
            </td>
            <td>
              <input *ngIf="!item.checkIfIsL4AndAboveEmployee" matInput type="time" [(ngModel)]="item.timeFrom" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredTimeFrom" />
            </td>
            <td>
              <input *ngIf="!item.checkIfIsL4AndAboveEmployee" matInput type="time" [(ngModel)]="item.timeTo" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredTimeTo" />
            </td>
            <td>
              <mat-slide-toggle [checked]="item.isRepetativeTask" [(ngModel)]="item.isRepetativeTask" [disabled]="!item?.isNew || !item.isCutoffTaskEditable"></mat-slide-toggle>
            </td>
            <td>
              <ng-select *ngIf="item?.dwmType && item?.dwmType == 'Monthly' && !item?.checkIfIsL4AndAboveEmployee" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency" [(ngModel)]="item.dwmFrequency" appendTo="body" dropdownPosition="top" [disabled]="!item.isRepetativeTask || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredFrequency">
                <ng-option *ngFor="let f of getMonthalyFrequency" [value]="f" [disabled]="f === 'HOURLY' && (!item?.timeFrom || !item?.timeTo)">{{ f }}</ng-option>
              </ng-select>
              <ng-select *ngIf="item?.dwmType && item?.dwmType == 'Monthly' && item?.checkIfIsL4AndAboveEmployee" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency" [(ngModel)]="item.dwmFrequency" [items]="getMonthalyFrequencyForL4AndAbove" appendTo="body" dropdownPosition="top" [disabled]="!item.isRepetativeTask || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredFrequency">
                <ng-option *ngFor="let f of getMonthalyFrequencyForL4AndAbove" [value]="f">{{ f }}</ng-option>
              </ng-select>
              <ng-select *ngIf="item?.dwmType && item?.dwmType == 'Annually'" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency" [(ngModel)]="item.dwmFrequency" [items]="getAnuallyFrequency" appendTo="body" dropdownPosition="top" [disabled]="!item.isRepetativeTask || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredFrequency">
                <ng-option *ngFor="let f of getAnuallyFrequency" [value]="f">{{ f }}</ng-option>
              </ng-select>
            </td>
            <td>
              <mat-form-field class="w-100 mw-sm-150 mat mat-height32 mat-input-style select-date-pikker" [class.field-required]="item?.isRequiredDwmDate">
                <input matInput [matDatepicker]="picker" placeholder="Select date" [(ngModel)]="item.dwmDate" [min]="today" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </td>
            <td class="text-center">
              <label class="star-checkbox">
                <input type="checkbox" [(ngModel)]="item.isCriticalTask" [disabled]="!(item.dwmStatus === 'Pending') && !item?.isNew || !item.isCutoffTaskEditable" />
                <svg viewBox="0 0 24 24" class="star"><polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9" /></svg>
              </label>
            </td>

            <td>{{ item.dwmStatus }}</td>

            <td>
              <div class="action-buttons">
                <button *ngIf="!item?.isNew" type="button" mat-icon-button color="primary" matTooltip="Approve" (click)="approveOrRejectDwm(item, 'Approved', i)" [disabled]="!(item.dwmStatus == 'Pending') || selectedTaskList?.length > 0 || !item.isCutoffTaskEditable">
                  <ion-icon name="checkmark-outline"></ion-icon>
                </button>
                <button *ngIf="!item?.isNew" type="button" mat-icon-button color="warn" matTooltip="Reject" (click)="approveOrRejectDwm(item, 'Rejected', i)" [disabled]="!(item.dwmStatus == 'Pending') || selectedTaskList?.length > 0 || !item.isCutoffTaskEditable">
                  <ion-icon name="close-outline"></ion-icon>
                </button>
                <button *ngIf="item?.isNew" type="button" mat-icon-button color="primary" matTooltip="Save" [disabled]="selectedTaskList?.length > 0 || !item.isCutoffTaskEditable" (click)="saveNewTask([item])">
                  <ion-icon name="checkmark-outline"></ion-icon>
                </button>
                <button *ngIf="item?.isNew" type="button" mat-icon-button color="warn" matTooltip="Removes" [disabled]="selectedTaskList?.length > 0 || !item.isCutoffTaskEditable" (click)="removeTask( paginatedData, i)">
                  <ion-icon name="trash-outline"></ion-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="paginatedData?.length">
      <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries</ion-label>

      <div class="phi-flex-wrap-center phi-gap-12">
        <div class="phi-flex-wrap-center phi-gap-8">
          <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" (selectionChange)="changePageSize($event.value)" [value]="pageSize">
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
        </div>

        <ul class="dt_pagination">
          <li class="active fs-16 fs_14ForMobile font_regular">{{ currentPage }}</li>
          <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalPages }}</span>
          <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage - 1)" [ngClass]="{ disableBtn: currentPage === 1 }">&lt;</li>
          <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage + 1)" [ngClass]="{ disableBtn: currentPage === totalPages }">&gt;</li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>
